// Boolean-ish flags on fields and options (`readonly`, `disabled`) arrive from
// the backend as a boolean, as 1/0 or as the string form of either.
export const isFlagOn = value =>
  value === true || value === 1 || value === '1' || value === 'true';
